export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtry"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stav"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obchod"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Účet"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Použít"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vymazat vše"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vybrat stav"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vybrat obchod"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadat číslo faktury"])}
}